import React, {useState} from 'react';
import {Link} from 'react-router-dom';

import './card.styles.css';
import Modal from '../modal/modal';


const Card = props => {

        // const [showFull, setShowFull] = useState(false);

        // const openFullHandler = () =>  setShowFull(true);
        // const closeFullHandler = () =>  setShowFull(false);


        return(
            <React.Fragment>               
                <div className="col-1-of-3">
                    <div className="card">
                        <div className="card__side card__side--front">
                                {/* <div className="card__picture card__picture--1">                        
                                    &nbsp;
                                </div> */}
                                <img src={props.image} className="card__picture card__picture--1" alt={props.naslov}/>

                                <h4 className="card__heading">
                                    <span className="card__heading-span card__heading-span--1">{props.naslov}</span>
                                </h4>
                                <div className="card__details">
                                    <ul>
                                        <li>  { (new Date(props.datum)).toLocaleDateString('en-GB') }</li>
                                        <li>{props.kategorija}</li>
                                        <li>{props.duzina} km</li>                                        
                                        <li>{props.visina}m </li>
                                        <li>Tezina Staze: {props.tezina}</li>
                                    </ul>
                                </div>
                        </div>
                        <div className="card__side card__side--back card__side--back-1">
                                <div className="card__cta">
                                    <div className="card__price-box">
                                        <p className="card__price-only">Okvirni troskovi</p>
                                        <p className="card__price-value">{props.cena} din</p>
                                    </div>
                                    <Link to={`najave/${props.id}`} className="btn btn--white">Više Informacija</Link>
                                </div>
                            </div>
                    </div>
                </div> 
        </React.Fragment>  
      
    )
};


export default Card;